const decodeRedirectState = (encoded: string): string | null => {
  try {
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.codePointAt(i)!;
    }
    const decoded = new TextDecoder('utf-8', { fatal: true }).decode(bytes);
    // Only allow same-origin in-app paths; reject protocol-relative ('//host')
    // and absolute URLs to prevent open-redirects via tampered state.
    if (!decoded.startsWith('/') || decoded.startsWith('//')) {
      return null;
    }
    return decoded;
  } catch {
    return null;
  }
};

export default decodeRedirectState;
